import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.png";
import image3 from "../assets/t-image3.png";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Wow, I really recommend this place for you if you want to have some fun while you do your workout! They have amazing staff that are super serious and makes you reach your goals with a smile on their faces!! Thank you Molyko Premier,",
    name: 'THEODORE NGO MANJI',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Molyko Premier is the cleanest and most organized gym I’ve ever seen! I have no words to say how wonderful they are! Ebot makes you feel super comfortable, Enanga helps you eat better and healthy!',
    name: 'ABIGAIL NDIFET',
    status: 'LAWYER'
  },
  {
    image : image3,
    review:' It has been almost one year and I have lost weight and increased my strength.  I find the coaches – so motivating and supportive. ',
    name: 'CHRISTABEL AGWETANG',
    status: "UNIVERSITY STUDENT"
  }
];
